import { render } from "./status_tag.vue?vue&type=template&id=1a42b876"
import script from "./status_tag.vue?vue&type=script&lang=js"
export * from "./status_tag.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__